import React from "react";
import { Row, Col } from "antd";
import "./SearchWidget.css";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { PlusOutlined, ArrowLeftOutlined } from "@ant-design/icons";

function SearchWidget(props) {
  const {
    onCreateNew,
    onBackToMessages,
  } = props;

  return (
    <Row className="follower-cnt-txt" align="middle" justify="space-between">
      <Col>
        <CommonButton
          onClick={() => {
            onBackToMessages();
          }}
        >
          <ArrowLeftOutlined />
          Back to Messages
        </CommonButton>
      </Col>
      <Col>
        <CommonButton
          onClick={() => {
            onCreateNew();
          }}
        >
          <PlusOutlined />
          Create New Audience
        </CommonButton>
      </Col>
    </Row>
  );
}

export default SearchWidget;
